/* Slick needs no get Reinitialized on window Resize after it was destroyed */
$(window).on("load resize orientationchange", function () {
  $(".mobile-slider:not(.product_blocks-swiper-wrapper.no-d)").each(function () {
    var $carousel = $(this);
    /* Initializes a slick carousel only on mobile screens */
    // slick on mobile
    if ($(window).width() > 750) {
      if ($carousel.hasClass("slick-initialized")) {
        $carousel.slick("unslick");
      }
    } else {
      if (!$carousel.hasClass("slick-initialized")) {
        $carousel.slick({
          slidesToShow: 2,
          slidesToScroll: 2,
          autoplay: false,
          autoplaySpeed: 2000,
          dots: false,
          infinite: false,
          arrows: false,
          mobileFirst: true,
          responsive: [
            {
              breakpoint: 560,
              settings: {
                slidesToShow: 4,
              },
            },
            {
              breakpoint: 375,
              settings: {
                slidesToShow: 2.75,
              },
            },
          ],
        });
      }
    }
  });

});

$(window).on("load resize orientationchange", function () {
  $(".pbcg_slider").each(function () {
    var $carousel = $(this);
    /* Initializes a slick carousel only on mobile screens */
    // slick on mobile
    if ($(window).width() > 749) {
      if ($carousel.hasClass("slick-initialized")) {
        $carousel.slick("unslick");
      }
    } else {
      if (!$carousel.hasClass("slick-initialized")) {
        $carousel.slick({
          slidesToShow: 1,
          slidesToScroll: 1,
          autoplay: false,
          dots: false,
          infinite: false,
          arrows: true,
          mobileFirst: true,
          prevArrow: $(".prev"),
          nextArrow: $(".next"),
        });
      }
    }
  });
});

$(document).ready(function () {
  

// SLICK SLIDER FOR Press Multicolumn
mobileOnlySlider(".press_multicolumn_logo_wrapper", true, false, 767);
  
function mobileOnlySlider($slidername, $dots, $arrows, $breakpoint) {
    var slider = $($slidername);
    
    if (slider.length === 0) {
        console.error("Slider element not found:", $slidername);
        return; // Exit if slider element is not found
    }

    var settings = {
        mobileFirst: true,
        slidesToShow: 2.5,
        arrows: false,
        infinite: false,
        dots: false,
        responsive: [
            {
                breakpoint: $breakpoint,
                settings: "unslick",
            },
        ],
    };

    if (!slider.hasClass('slick-initialized')) {
      slider.slick(settings);
    }

    $(window).on("resize", function () {
        if ($(window).width() > $breakpoint) {
            return;
        }
        if (!slider.hasClass("slick-initialized")) {
            return slider.slick(settings);
        }
    });
}

  

  //slick slider for social media post section


  mobileOnlySlider_gallery(".image_gallary_container", true, false, 767);
  function mobileOnlySlider_gallery($slidername, $dots, $arrows, $breakpoint) {
    var slider = $($slidername);
    var settings = {
      mobileFirst: true,
      slidesToShow: 1.4,
      arrows: false,
      infinite: false,
      dots: true,
      responsive: [
        {
          breakpoint: $breakpoint,
          settings: "unslick",
        },
        {
          breakpoint: 500,
          settings: {
            slidesToShow: 2.2,
            infinite: false,
            slidesToScroll: 1,
          },
        },
      ],
    };

    if (!slider.hasClass('slick-initialized')) {
      slider.slick(settings);
    }
    
    $(window).on("resize", function () {
      if ($(window).width() > $breakpoint) {
        return;
      }
      if (!slider.hasClass("slick-initialized")) {
        return slider.slick(settings);
      }
    });
  }

  // SLICK SLIDER FOR Data blocks(bubbles)
  mobileOnlySliderBlocks(".data-blocks-slider", true, false, 989);

  function mobileOnlySliderBlocks($slidername, $dots, $arrows, $breakpoint) {
    var slider = $($slidername);
    var settings = {
      autoplay: true,
      autoplaySpeed: 4000,
      mobileFirst: true,
      slidesToShow: 1,
      slidesToScroll: 1,
      arrows: $arrows,
      infinite: false,
      dots: $dots,
      responsive: [
        {
          breakpoint: $breakpoint,
          settings: "unslick",
        },
      ],
    };

    if (!slider.hasClass('slick-initialized')) {
      slider.slick(settings);
    }

    $(window).on("resize", function () {
      if ($(window).width() > $breakpoint) {
        return;
      }
      if (!slider.hasClass("slick-initialized")) {
        return slider.slick(settings);
      }
    });
  } // Mobile Only Slider

  // document load end
});

//PRODUCT RECOMMENDATIONS SLIDER
function sliderInit() {
 $(".prod-recommend-slider").not('.slick-initialized').slick({
    autoplay: true,
    autoplaySpeed: 3000,
    infinite: false,
    slidesToShow: 3,
    slidesToScroll: 1,
    arrows: false,
    dots: false,
    responsive: [
      {
        breakpoint: 749,
        settings: {
          slidesToShow: 2.35,
        },
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 1.5,
        },
      },
      {
        breakpoint: 400,
        settings: {
          slidesToShow: 1,
          arrows: true,
          prevArrow: $(".prev"),
          nextArrow: $(".next")
        },
      },
    ],
  });
}

$(".product_blocks-wrapper.mobile-slider:not(.swiper-container)").not('.slick-initialized').slick({
  slidesToShow: 2.5,
  slidesToScroll: 1,
  autoplay: false,
  dots: false,
  infinite: false,
  arrows: false,
  focusOnSelect: true,
  responsive: [
  ]
});